module.exports = __webpack_public_path__ + "img/pending_approval.e68835c0.png";